import { Component, Input, inject } from "@angular/core";
import { HssTimePipe } from "../pipes/hss-time.pipe";
import { Hss } from "../models/hss";
import { HssLeg } from "../models/hss-leg";
import { HssBuilderService } from "../hss-builder.service";

@Component({
  selector: "app-split-duty-rest",
  standalone: true,
  imports: [HssTimePipe],
  templateUrl: "./split-duty-rest.component.html",
  styleUrls: [
    "./split-duty-rest.component.scss",
    "../hss-builder.component.scss",
  ],
})
export class SplitDutyRestComponent {
  @Input({ required: true }) hss!: Hss;
  @Input({ required: true }) leg!: HssLeg;
  @Input() isAct?: boolean; // Act row (vs SKD)
  @Input() isCba?: boolean; // CBA row (REST  CBA)
  @Input() enhanced?: boolean;
  @Input() index?: number;

  hssBuilderService = inject(HssBuilderService);
}
